module.exports = __webpack_public_path__ + "static/img/akum_600_65.c50d446.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_65.svg
// module id = 7F4b
// module chunks = 1